import React from 'react';
import {
  focusEditor,
  useEventPlateId,
  usePlateEditorRef,
  insertNodes,
  ELEMENT_HR,
  ELEMENT_DEFAULT,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import { ToolbarButton } from './ToolbarButton';

export const HrButton = ({ id, ...props }) => {
  const editor = usePlateEditorRef(useEventPlateId(id));

  return (
    <ToolbarButton
      name="Insert line"
      className={clsx('button--unstyled')}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        insertNodes(
          editor,
          [
            { type: ELEMENT_HR, children: [{ text: '' }] },
            { type: ELEMENT_DEFAULT, children: [{ text: '' }] },
          ],
        );
        focusEditor(editor);
      }}
      onMouseDown={(e) => e.preventDefault()}
      {...props}
    >
      <FontAwesomeIcon icon={['fa', 'horizontal-rule']} />
    </ToolbarButton>
  );
};
